/**
 * Color palette exports for use in JS contexts (SVG fills, inline styles, etc.)
 * These are hex approximations of the OKLCH values defined in globals.css @theme.
 * Source of truth: src/styles/globals.css
 */

export const purple = {
  "50": "#faf4ff",
  "100": "#f3e6ff",
  "200": "#e9d1ff",
  "300": "#d8adff",
  "400": "#c179ff",
  "500": "#a947ff",
  "600": "#9523fa",
  "700": "#7a12d3",
  "800": "#6d15b4",
  "900": "#591390",
  "950": "#3c006c",
};

export const violet = {
  "50": "#eef1ff",
  "100": "#e0e5ff",
  "200": "#c7cefe",
  "300": "#a4adfd",
  "400": "#8081f9",
  "500": "#6a62f2",
  "600": "#614ce7",
  "700": "#4e37cb",
  "800": "#3f2fa4",
  "900": "#372d82",
  "950": "#221b4b",
};

export const orange = {
  "50": "#fef8ec",
  "100": "#fcebc9",
  "200": "#fad58d",
  "300": "#f7b952",
  "400": "#f59f2a",
  "500": "#ef8017",
  "600": "#d35b0c",
  "700": "#af3d0e",
  "800": "#8e2f12",
  "900": "#752812",
  "950": "#431205",
};

export const gray = {
  "25": "#fdfcfd",
  "50": "#fbf9fc",
  "100": "#f6f3f9",
  "200": "#ece4f2",
  "300": "#dbd0e4",
  "400": "#a79bb0",
  "500": "#776e7e",
  "600": "#595061",
  "700": "#463c4e",
  "800": "#2c2533",
  "900": "#1c1520",
  "950": "#0a050d",
};

export const brand = purple;
